import React from 'react';
import { Link } from 'react-router-dom';
import FullLogo from '../Photos/Fulllogo.png';
import GeneralImage from '../Photos/generalimage.jpg';
import Gates1 from '../Photos/gates1.jpg';
import Gates2 from '../Photos/gates2.jpg';
import Gates3 from '../Photos/gates3.jpg';
import Gates4 from '../Photos/gates4.jpg';
import Gates5 from "../Photos/gates5.png"
import Custom5 from '../Photos/custom5.jpg';




function Gates() {
  return (
    <div className="container mt-5">
     
      {/* Introduction Section */}
      <div className="row mt-5 mb-5">
        <div className="col-md-8">
          <h2 className="text-success">Custom Gates</h2>
          <p className="lead">Our custom gates can be tailored to your application. Custom lengths as well as custom swinging and free standing options will ensure that you can get what you need. </p>
          <p className="text-muted"></p>
        </div>
        <div className="col-md-4">
          <img src={Gates2} alt="Side Image" className="img-fluid rounded" />
        </div>
      </div>

      {/* Informational Box */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={Gates5} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Built to length</h4>
              <p className="card-text">We build to the length you need. Larger gates will have the added support that is needed so just call tell us your length. </p>
              <h6 className="card-title text-primary"></h6>
            </div>
          </div>
        </div>
      </div>

      {/* Informational Box with Image on Right */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Mounting Solutions</h4>
              <p className="card-text">Whether mounted to a gate or used as a standalone unit, we can adapt the design to fit your application. Our standard option includes welded hinge mounts, but we can also tailor the mounting system to your needs — including adding legs for portable use.</p>
              
            </div>
          </div>
          <div className="col-md-4">
            <img src={Gates3} className="img-fluid rounded-end" alt="Info Image" />
          </div>
        </div>
      </div>


       {/* Informational Box */}
      <div className="card mb-5 shadow-sm get-in-touch-card">
        <div className="row g-0">
          <div className="col-md-4">
            <img src={Custom5} className="img-fluid rounded-start" alt="Info Image" />
          </div>
          <div className="col-md-8">
            <div className="card-body">
              <h4 className="card-title text-primary">Complete Soulutions</h4>
              <p className="card-text"> Need something purpose built or a complete system. Feel free to reach out or visit the purpose built page to see how we can meet your needs. </p>
              <button className="btn-custom">
                <Link to="/PurposeBuilt" style={{ color: 'inherit', textDecoration: 'none' }}>Purpose Built Page</Link>
              </button>
            </div>
          </div>
        </div>
      </div>

     

     

      {/* Google Maps and Address Section */}
      <div className="row mb-5">
        <div className="col-md-6">
          <h3 className="text-info mb-3">Find Us on the Map</h3>
          <iframe
            title="Google Map Location"
             src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d137778.5034484805!2d-96.8170804273567!3d40.26456281736707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x879642a907fb410b%3A0x92e39ab059d18d3d!2sBeatrice%2C%20NE%2068310!5e0!3m2!1sen!2sus!4v1756762112857!5m2!1sen!2sus" 
            width="100%"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        <div className="col-md-6 d-flex flex-column">
          <h3 className="text-info mb-3">Contact Us</h3>
          <div className="card p-3 enlarged-address-card flex-grow-1">
            <p className="card-text">
         Location: <br />
              
            
              Beatrice, NE 68310<br />
              <br />
              <br />
              Email: eoltmans3@gmail.com<br />
              <br />
              Phone: (402) 239-4323
            </p>
          </div>
          <div className="flex-grow-1 mt-3">
            <img src={FullLogo} alt="Company Logo" className="img-fluid w-100" style={{ width: '100%', objectFit: 'cover' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gates;